import { render, staticRenderFns } from "./suoritemerkinnat.vue?vue&type=template&id=7fdb9874&scoped=true&"
import script from "./suoritemerkinnat.vue?vue&type=script&lang=ts&"
export * from "./suoritemerkinnat.vue?vue&type=script&lang=ts&"
import style0 from "./suoritemerkinnat.vue?vue&type=style&index=0&id=7fdb9874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdb9874",
  null
  
)

export default component.exports